import { Button, Stack, styled, Tooltip, Typography } from "@mui/material";
import { grey } from "@mui/material/colors";
import LinearProgress, {
  linearProgressClasses,
} from "@mui/material/LinearProgress";
import { useState } from "react";
import { useSelector } from "react-redux";

const PremiumTrialBox = styled(Stack)(({ theme }) => ({
  margin: theme.spacing(3, 2),
  padding: theme.spacing(2),
  backgroundColor: "#fffbe5",
  borderRadius: theme.shape.borderRadius,
  border: "1px solid #ffe0b2",
}));
const BorderLinearProgress = styled(LinearProgress)(({ theme }) => ({
  height: 10,
  borderRadius: 5,
  [`&.${linearProgressClasses.colorPrimary}`]: {
    backgroundColor:
      theme.palette.grey[theme.palette.mode === "light" ? 200 : 800],
  },
  [`& .${linearProgressClasses.bar}`]: {
    borderRadius: 5,
    backgroundColor: theme.palette.primary.main, // theme.palette.mode === "light" ? "#1a90ff" : "#308fe8",
  },
}));
const DismissButton = styled(Button)(({ theme }) => ({
  marginTop: theme.spacing(1),
  color: grey[600],
  textTransform: "none",
}));
const UpgradeButton = styled(Button)(({ theme }) => ({
  marginTop: theme.spacing(1),
  color: theme.palette.button.link,
  textTransform: "none",
  fontWeight: "bold",
}));

const SubscriptionInfo = () => {
  const recentSub = useSelector((state) => state.subscriptions);
  const [showPlanBox, setshowPlanBox] = useState(true);

  const startDate = new Date(
    recentSub?.currentPeriodStart ?? recentSub?.currentPeriodStart ?? ""
  );
  const endDate = new Date(recentSub?.currentPeriodEnd ?? "");
  const now = new Date();

  const totalDays = Math.ceil(
    (endDate.getTime() - startDate.getTime()) / (1000 * 60 * 60 * 24)
  );
  const elapsedDays = Math.min(
    Math.ceil((now.getTime() - startDate.getTime()) / (1000 * 60 * 60 * 24)),
    totalDays
  );

  const progressPercent = (elapsedDays / totalDays) * 100;

  const getProgressInfo = (percent) => {
    if (percent <= 50) return { label: "Normal", color: "text.secondary" };
    if (percent <= 85) return { label: "Caution", color: "#FFAA01" };
    return { label: "Critical", color: "#FF0000" };
  };

  return (
    <>
      {showPlanBox && (
        <PremiumTrialBox
          className="agent-subscription"
          justifyContent="flex-start"
          gap={2}
        >
          <Stack>
            <Typography
              variant="smallBold"
              component="h4"
              mb={1}
              sx={{ textTransform: "capitalize" }}
            >
              {recentSub.package
                ? recentSub?.package?.replace(/-/g, " ")
                : "No Premier Agent Plan"}
            </Typography>

            <Typography
              variant="small"
              component="p"
              color={getProgressInfo(progressPercent).color}
            >
              {recentSub ? (
                <>
                  Subscription time period – On day {elapsedDays} of {totalDays}
                </>
              ) : (
                "You’re currently not on a trial or active plan."
              )}
            </Typography>
          </Stack>

          <Tooltip
            title={`${progressPercent.toFixed(0)}% used – ${
              getProgressInfo(progressPercent).label
            }`}
            placement="bottom"
          >
            <BorderLinearProgress
              variant="determinate"
              sx={{
                cursor: "pointer",
                "& .MuiLinearProgress-bar": {
                  backgroundColor: getProgressInfo(progressPercent).color,
                },
              }}
              value={recentSub ? progressPercent : 0}
            />
          </Tooltip>

          <Stack direction="row" gap={2}>
            <DismissButton
              variant="text"
              size="small"
              onClick={() => setshowPlanBox()}
            >
              <Typography variant="smallBold">Dismiss</Typography>
            </DismissButton>
            <UpgradeButton variant="text" size="small" href="/pricing">
              <Typography variant="smallBold">Upgrade Plan</Typography>
            </UpgradeButton>
          </Stack>
        </PremiumTrialBox>
      )}
    </>
  );
};

export default SubscriptionInfo;
